import { create } from 'zustand';
import { Stock } from '../types';
import { apiService } from '../services/api';

interface StocksState {
    stocks: Stock[] | null;
    loading: boolean;
    error: string | null;
    lastFetched: number | null;
    fetchStocks: () => Promise<void>;
    refetchStocks: () => Promise<void>;
}

const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export const useStocksStore = create<StocksState>((set, get) => ({
    stocks: null,
    loading: false,
    error: null,
    lastFetched: null,

    fetchStocks: async () => {
        const state = get();
        const now = Date.now();

        // Return cached data if still valid
        if (state.stocks && state.lastFetched && (now - state.lastFetched) < CACHE_DURATION) {
            return;
        }

        // If already loading, don't fetch again
        if (state.loading) {
            return;
        }

        set({ loading: true, error: null });

        try {
            const stocks = await apiService.getStocks();
            set({
                stocks,
                loading: false,
                error: null,
                lastFetched: now
            });
        } catch (error) {
            set({
                error: error instanceof Error ? error.message : 'Failed to fetch stocks',
                loading: false
            });
        }
    },

    refetchStocks: async () => {
        set({ lastFetched: null }); // Clear cache
        return get().fetchStocks();
    }
}));
